/* Import dependencies and components */
import { mapGetters } from "vuex";
import * as Service from "./ManageUsers.service";
import moment from "moment";
import Profile from "../../components/Profile/Profile/Profile";
import { GetUserDetails, GetUserRoles } from "../../config/app.config";
import * as userService from "../../Service/User.service";
import { GetRoles } from "../../Constants/RolesConstants";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";
import AreaTeamOfficeComponent from "../../components/AreaTeamOfficeComponent/AreaTeamOffice";

/* Logic of Manage User controller */
export default {
  components: {
    Profile,
    AreaTeamOfficeComponent
  },
  data() {
    return {
      selectedUserId: 0,
      showAreaTeamAssignPopup: false,
      previousStates: [],
      registeredUserSearch: "",
      unRegisteredUserSearch: "",
      roles: GetRoles(),
      users: [],
      unRegisteredUsersheaders: [
        {
          text: "Full Name ",
          sortable: true,
          value: "FirstName",
          class: "datatable-columnheader"
        },


        {
          text: "Area",
          sortable: true,
          value: "Area",
          class: "datatable-columnheader"
        },
        {
          text: "Team",
          value: "Team",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Office",
          value: "Office",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Group",
          value: "Group",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Role ",
          value: "RoleName",
          sortable: true,
          class: "datatable-columnheader"
        },

        {
          text: "Action",
          value: "",
          sortable: false,
          class: "datatable-columnheader"
        }
      ],
      registeredUsersheaders: [
        {
          text: "First Name ",
          sortable: true,
          value: "FirstName",
          class: "datatable-columnheader"
        },
        {
          text: "Last Name ",
          sortable: true,
          value: "LastName",
          class: "datatable-columnheader"
        },
        {
          text: "Email ",
          sortable: true,
          value: "Email",
          class: "datatable-columnheader"
        },
        {
          text: "Area",
          sortable: true,
          value: "Area",
          class: "datatable-columnheader"
        },
        {
          text: "Team",
          value: "Team",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Office",
          value: "Office",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Group",
          value: "Group",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Role ",
          value: "RoleName",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Last Active  ",
          value: "LastActivity",
          sortable: true,
          class: "datatable-columnheader"
        },

        {
          text: "IsActive",
          value: "IsActive",
          sortable: true,
          class: "datatable-columnheader"
        },
        {
          text: "Action",
          value: "",
          sortable: false,
          class: "datatable-columnheader"
        }
      ]
    };
  },
  computed: {
    registeredUsers() {
      return this.users.filter(x => x.IsRegistered == true);
    },
    unRegisteredUsers() {
      return this.users.filter(x => x.IsRegistered == false);
    },
    ...mapGetters([
      "getGroupByList"
    ])
  },
  async mounted() {
    await this.GetUserList();
  },
  methods: {
    openAreaAssignModal(employeeId) {
      this.showAreaTeamAssignPopup = true;
      this.selectedUserId = employeeId;
    },
    async GetUserList() {
      let context = this;

      var result = await userService.GetRegisteredAndUnRegisteredUsers();

      if (result.error == false) {
        result.data.forEach(element => {
          element.isEdit = false;
        });
        this.users = result.data;
      }
    },

    async RegisterUser(item) {
      let context = this;
      var result = await userService.RegisterUser(item);

      if (result.error == false) {
        this.$store.commit(
          "toaster",
          toasterModel("Successfully Registered", toasterColor.success)
        );
        await context.GetUserList();
      } else {
        this.$store.commit(
          "toaster",
          toasterModel("Registration Failed", toasterColor.info)
        );
      }
    },
    async ChangeUserPermission(selectedUser) {
      var result = await userService.ChangeUserPermissionForAnApplication(
        selectedUser
      );

      if (result.error == false) {
        this.$store.commit(
          "toaster",
          toasterModel("Saved Successfully", toasterColor.success)
        );
        selectedUser.isEdit = false;
      } else {
        this.$store.commit(
          "toaster",
          toasterModel("Failed", toasterColor.info)
        );
      }
    },

    cancelEdit(selectedUser) {
      var previousState = this.previousStates.filter(
        x => x.EmployeeId == selectedUser.EmployeeId
      )[0];

      selectedUser.RoleName = previousState.RoleName;
      selectedUser.IsActive = previousState.IsActive;
      selectedUser.isEdit = false;
    },
    EditUser(item) {
      var previousState = JSON.parse(JSON.stringify(item));

      var index = this.previousStates.findIndex(
        x => x.EmployeeId == previousState.EmployeeId
      );
      if (index != -1) {
        this.previousStates.splice(index, 1);
      }

      this.previousStates.push(previousState);

      item.isEdit = !item.isEdit;
    }
  },

  beforeDestroy() {
    this.$router.app.$off("toastTrigger");
  }
};
